import axios from 'axios';
import $$auth from 'models/auth';

// eslint-disable-next-line unused-imports/no-unused-imports
import env from 'constants/env';

import LoginAsUserService from 'services/LoginAsUserService';

export const API_URL = env.REACT_APP_API_URL;
// export const API_URL = 'http://localhost:8090';

const APIHelper = {
    getToken: async () => {
        try {
            return (await $$auth.currentSessionFx()).getIdToken().getJwtToken();
        } catch (error) {
            // Some requests (address lookup, email availability) are made for unauthorized user,
            // so error is expected here.
        }
    },

    setupInterceptors: () => {
        axios.interceptors.request.use(async (config) => {
            config.baseURL = API_URL;

            if (!config.headers) {
                config.headers = {};
            }
            if (!config.url?.startsWith('https')) {
                const token = await APIHelper.getToken();
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }

                const onBehalfOf = LoginAsUserService.getAwsId();
                if (onBehalfOf && !config.url?.endsWith('/logout')) {
                    config.headers['X-On-Behalf-Of'] = onBehalfOf;
                }
            }

            // @ts-ignore
            if (config.headers[config?.method as string][`Content-Type`] === `application/x-www-form-urlencoded`) {
                // @ts-ignore
                delete config.headers[config?.method as string][`Content-Type`];
            }

            // @ts-ignore
            if (config.headers?.common?.Accept === `application/json, text/plain, */*` && config.method === `put`) {
                config.headers['Content-Type'] = `application/json`;
            }

            return config;
        }, Promise.reject);
    },
};

export default APIHelper;
